import React from 'react';
import PropTypes from 'prop-types';
import { InsertAnchorDialog } from '../../../content-edit-controls';

const InsertAnchorDialogWindow = ({
  onSave,
  onCancel,
  params
}) =>
{
  const { name, index, isEditMode } = params;

  const handleSave = (anchorName) =>
  {
    onSave({ name: anchorName, index });
  };

  return (
    <InsertAnchorDialog
      isEditMode={isEditMode}
      onSave={handleSave}
      onCancel={onCancel}
      value={name}
    />
  );
};

InsertAnchorDialogWindow.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  params: PropTypes.shape({}).isRequired
};

export default InsertAnchorDialogWindow;